class domFn {
  constructor() {}
  addListen(dom, event, fn) {
    if (dom.addEventListener) {
      // 所有主流浏览器，除了 IE 8 及更早版本
      dom.addEventListener(event, fn);
    } else if (dom.attachEvent) {
      // IE 8 及更早版本
      dom.attachEvent(`on${event}`, fn);
    }
  }
  removeEvent(element, type, handler) {
    if (element.removeEventListener) {
      element.removeEventListener(type, handler, false);
    } else if (element.detachEvent) {
      // detachEvent是ie的事件监听
      element.detachEvent('on' + type, handler);
    } else {
      element['on' + type] = null;
    }
  }
  remove(dom) {
    var navigatorName = 'Microsoft Internet Explorer';
    if (navigator.appName == navigatorName) {
      dom.removeNode(true);
    } else {
      dom.remove();
    }
  }
  // 二次解析后台返回的dom内容
  decodeHtml(str) {
    if (typeof window !== 'undefined') {
      let htmlObj = document.createElement('div');
      htmlObj.innerHTML = str;
      let content = htmlObj.innerText;
      this.remove(htmlObj);
      return content;
    } else {
      return '';
    }
  }
  addAnimateClass(dom, animateClass) {
    this.toggleClass(dom, animateClass);
    this.once(
      dom,
      'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
      () => {
        this.removeClass(dom, animateClass);
      }
    );
  }
  // 摇晃效果
  shake(dom) {
    this.toggleClass(dom, 'shake animated');
    this.once(
      dom,
      'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
      () => {
        this.removeClass(dom, 'shake animated');
      }
    );
  }
  //   一次执行
  once(dom, type, callback) {
    type = type.split(' ');
    for (let item of type) {
      let handle = () => {
        callback();
        dom.removeEventListener(item, handle);
      };
      dom.addEventListener(item, handle);
    }
  }
  hasClass(dom, cls) {
    return dom.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
  }
  addClass(dom, cls) {
    if (!this.hasClass(dom, cls)) dom.className += ' ' + cls;
  }
  removeClass(dom, cls) {
    if (this.hasClass(dom, cls)) {
      var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
      dom.className = dom.className.replace(reg, ' ');
    }
  }
  toggleClass(dom, cls) {
    if (this.hasClass(dom, cls)) {
      this.removeClass(dom, cls);
    } else {
      this.addClass(dom, cls);
    }
  }
}
export default new domFn();
